<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-row class="text-center">
            <b-col sm="12">
                <div>
                    <b-form-input
                            class="margininputs"
                            v-model="filtro"
                            type="search"
                            id="filterInput"
                            placeholder="Búsqueda clinicas"
                            @keydown.enter.native="buscarClinicas()"
                    ></b-form-input>
                    <b-table
                            small
                            :fields="fields"
                            :items="items"
                            :per-page="$registrosPorPaginaTabla"
                            :current-page="currentPage"
                            responsive="sm"
                            thead-tr-class="columnas"
                            caption-top>
                        <template
                                v-slot:cell(Acciones)="row"
                                style="width: 200px">
                            <b-button size="sm" variant="primary" class="mr-1 marginbotones"
                                      v-if="$localStorageService.can('BO_28_clini_Inactiva_react')"
                                      v-b-tooltip.hover
                                      title="Reactivar"
                                      @click="reactivar(row.item.idClinica, row.item.strNombre)">
                                <b-icon icon="arrow-counterclockwise" aria-label="Help"></b-icon>
                            </b-button>

                        </template>
                    </b-table>
                    <div align="center" v-if="loading">
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <b-col v-else>
                        <b-alert v-if="items.length === 0" variant="warning" show>No hay datos</b-alert>
                    </b-col>
                    <b-pagination
                            align="center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="$registrosPorPaginaTabla"
                    ></b-pagination>
                </div>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    export default {
        name: "clinicasInactivas",
        props: {
            filtro: String
        },
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                loading: false,
                fields: [
                    {key: "idClinica", label: "Id clínica", sortable: true},
                    {key: "nombreEstado", label: "Estado", sortable: true},
                    {key: "zonaNombre", label: "Región", sortable: true},
                    {key: "strNombre", label: "Clínica", sortable: true},
                    {key: "strNombreCorto", label: "Nombre corto", sortable: true},
                    {key: "tipoClinica", label: "Tipo", sortable: true},
                    {key: "numeroSillones", label: "Sillones", sortable: true},
                    {key: "blnRegistraIngresos", label: "Registra ingresos", sortable: true, formatter: this.$formatoSINOFuncion},
                    {key: "escanerFits", label: "Tiene scanner fits", sortable: true, formatter: this.$formatoSINOFuncion},
                    "Acciones",
                ],
                currentPage: 1,
                items: []
            };
        },
        mounted() {
            this.buscarClinicas();
        },
      created() {
        this.debug = this.$localStorageService.getDebug();
      },
      methods: {
            buscarClinicas() {
                this.currentPage = 1;
                this.loading = true;
                this.items = [];
                const parametros = {detalle: this.filtro}
                this.$http
                    .post(this.$api + "catalogos/listaClinicasInactivas", parametros)
                    .then((response) => {
                        this.items = response.data.data;
                    }).finally(() => {
                    this.loading = false;
                });
            },
            reactivar(idClinica, nombreClinica) {

                this.$swal.fire({
                    title: "¿Desea dar de alta la clínica?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar",
                    showLoaderOnConfirm: true,

                    preConfirm: () => {
                        this.loading = true;
                        const params = {
                          idClinica: idClinica,
                          registroActivo: true,
                        }
                        this.$http
                            .put(this.$api + "catalogos/activarDesactivarClinica", params)
                            .then((response) => {
                                this.filtro = nombreClinica;
                                this.buscarClinicas();
                                this.$swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: "Se reactivó la clínica "+response.data.data,
                                    showConfirmButton: false,
                                    timer: 3500,
                                });
                            }).finally(() => {
                            this.loading = false;
                        });
                    },
                });

            }
        },
        computed: {
            rows() {
                return this.items.length;
            }
        },
        watch: {
            filtro() {
                this.$emit("actualizarFiltro", this.filtro);
            }
        }
    };
</script>
